module.exports = __webpack_public_path__ + "img/directory.1748e85a.svg";